module.exports = __webpack_public_path__ + "static/6305-woodrose-28-4459d4689f7af2267624a4e4ba85ae96.jpg";